import script from "./VVVRevenueNew.vue?vue&type=script&setup=true&lang=js"
export * from "./VVVRevenueNew.vue?vue&type=script&setup=true&lang=js"

import "./VVVRevenueNew.vue?vue&type=style&index=0&id=99c9fd3c&scoped=true&lang=css"

import exportComponent from "D:\\a\\1\\s\\CSD.SPA\\ClientApp\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-99c9fd3c"]])

export default __exports__